import { render, staticRenderFns } from "./CClassifiedSellerCard.vue?vue&type=template&id=9d0de49a&scoped=true&"
import script from "./CClassifiedSellerCard.vue?vue&type=script&lang=ts&"
export * from "./CClassifiedSellerCard.vue?vue&type=script&lang=ts&"
import style0 from "./CClassifiedSellerCard.vue?vue&type=style&index=0&id=9d0de49a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0de49a",
  null
  
)

export default component.exports